module.exports = __webpack_public_path__ + "img/btn.96d34775.png";